import type { FunkitTheme } from './toRestyleTheme'

/**
 * The button token's corner radius at a given height, for controls that clip
 * their own content and so need the number rather than the token name.
 *
 * Capped at half the height: the token's pill default (999) would otherwise
 * clip past the control's own corners on anything but a `borderRadius` prop.
 */
export function buttonRadius(theme: FunkitTheme, height: number): number {
  return Math.min(theme.borderRadii.button, height / 2)
}
